<template>
  <div class="pa-6">
    <!-- Card creación rápida -->
    <v-card v-if="puedeEditar" class="mb-6 rounded-lg elevation-2 border-left-primary">
      <v-card-text>
        <v-row align="center" no-gutters>
          <v-col class="d-flex align-center">
            <v-icon color="primary" class="mr-3">mdi-plus-circle-outline</v-icon>
            <v-text-field
              v-model="nuevoArmario"
              label="Nombre del nuevo armario raíz"
              dense
              outlined
              hide-details
              @keyup.enter="emitCrearArmario"
            />
          </v-col>
          <v-col cols="auto" class="pl-4">
            <v-btn color="primary" depressed @click="emitCrearArmario" :disabled="!nuevoArmario">
              Crear Armario
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Árbol -->
    <v-card class="tree-container rounded-lg elevation-2 pa-4" @click.self="$emit('clear-selected')">
      <v-text-field
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        label="Buscar armario por nombre..."
        outlined
        dense
        clearable
        class="mb-4 white elevation-1 rounded-lg"
        hide-details
        @click:clear="onClearSearch"
      />

      <div v-if="filteredTree && filteredTree.length > 0">
        <TreeNode
          v-for="node in filteredTree"
          :key="node.id"
          :node="node"
          :usuarios="usuarios"
          :selectedNode="selectedNode"
          :search-query="searchQuery"
          :verPlanos="verPlanos"
          :puedeEditar="puedeEditar"
          :puedeAdjuntar="puedeAdjuntar"
          @cambiar-padre="$emit('cambiar-padre', $event)"
          @select="$emit('select-node', $event)"
          @add-subnode="$emit('add-subnode', $event)"
          @edit-title="$emit('edit-title', $event)"
          @remove-node="$emit('remove-node', $event)"
          @attach-file="$emit('attach-file', $event)"
          @view-files="$emit('view-files', $event)"
          @ver-plano="$emit('ver-plano', $event)"
          @toggle="$emit('toggle', $event)"
          @ver-qr="$emit('ver-qr', $event)"
        />
      </div>

      <div v-else class="text-center pa-12 grey--text">
        <v-icon size="64" color="grey lighten-2">mdi-family-tree</v-icon>
        <p class="mt-4">Inicia la jerarquía creando un armario raíz</p>
      </div>
    </v-card>
  </div>
</template>

<script>
import TreeNode from "@/components/TreeNode.vue";

export default {
  name: "ArmariosTreeView",
  components: { TreeNode },
  props: {
    treeData: { type: Array, default: () => [] },
    usuarios: { type: Array, default: () => [] },
    selectedNode: { type: Object, default: null },
    searchQueryId: { type: String, default: "" },

    verPlanos: {type: Boolean, default: true},
    puedeEditar: {type: Boolean, default: true},
    puedeAdjuntar: {type: Boolean, default: true},
  },
  data() {
    return {
      searchQuery: "",
      nuevoArmario: "",
    };
  },
  watch: {
    searchQueryId: {
      handler(newVal) {
        this.searchQuery = newVal;
      },
      immediate: true,
    },
  },
  computed: {
    filteredTree() {
      if (!this.searchQuery) return this.treeData;

      const raw = this.searchQuery.trim();
      const query = raw.toLowerCase();

      const byId= query.startsWith("$");
      const q = byId ? query.slice(1).trim() : query;
      if (!q) return this.treeData;


      const filterNodes = (nodes) => {
        return nodes.reduce((acc, node) => {
          const filteredChildren = node.children ? filterNodes(node.children) : [];
          
          const name = (node.name || "").toLowerCase();
          const idStr = String(node.id ?? "");

          const matches = byId ? idStr.includes(q) : name.includes(q);

          if (matches || filteredChildren.length > 0) {
            acc.push({
              ...node,
              children: filteredChildren,
              expanded: true, // forzar expandido en búsqueda
            });
          }
          return acc;
        }, []);
      };

      return filterNodes(this.treeData);
    },
  },
  methods: {
    onClearSearch(){
      this.searchQuery = "";
      this.$emit("update:searchQueryId","");
    },
    emitCrearArmario() {
      const name = (this.nuevoArmario || "").trim();
      if (!name) return;
      this.$emit("crear-armario-raiz", name);
      this.nuevoArmario = "";
    },
  },
};
</script>

<style scoped>
.tree-container {
  min-height: 500px;
  background-color: white;
  border: 1px solid #e0e4e9;
}
.border-left-primary {
  border-left: 4px solid #1976d2 !important;
}
</style>